<template>
<v-app>
  <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
    <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only"  />
    <v-container fluid fill-height align-start>
      <v-row>
        <v-col md="12" lg="12" cols="12">
       <v-card  color="#393E46" class="text-center">
         <v-card-title class="text-center">
           <h2 class="text-h2 text-center">Diseño de Página de Membresia</h2>
         </v-card-title>
         <v-card-text>
           <v-row>
             <v-col cols="12" lg="4" md="4">
                <v-card>
                  <v-card-title>
                    Componentes
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="mb-0 pb-0">
                        <v-switch v-model="campoapmaterno" label="Campo Apellido Materno" ></v-switch>
                      </v-col>
                      <v-col cols="12" class="mb-0 pb-0 mt-0 pt-0">
                        <v-switch v-model="campotelefono" label="Campo Telefono" ></v-switch>
                      </v-col>
                      <v-col cols="12" class="mb-0 pb-0 mt-0 pt-0">
                        <v-switch v-model="campodireccion" label="Campo Direccion" ></v-switch>
                      </v-col>
                      <v-col cols="12" class="mb-0 pb-0 mt-0 pt-0">
                        <v-switch v-model="campodistrito" label="Campo Distrito" ></v-switch>
                      </v-col>
                      <v-col cols="12" class="mb-0 pb-0 mt-0 pt-0">
                        <v-switch v-model="campofecnac" label="Campo Fecha Nacimiento" ></v-switch>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
             </v-col>
             <v-col cols="12" lg="8" md="8">
                <v-card>
                  <v-card-title>Previsualización</v-card-title>
                  <v-card-text>
                    <v-row justify="center" >
                      <v-col cols="11" style="height: 500px; width: 100%; background-color: black">
                       <v-row justify="center" align="center" class="text-center">
                         <v-col cols="12" class="text-center">
                   <center> <v-img :src="negocio.logo90" width="50px"></v-img></center>
                         </v-col>
                       </v-row>
                        <v-row>
                          <v-col cols="2">

                          </v-col>
                          <v-col cols="8">
                            <section id="main-cabecera" class="ma-lg-12 ma-md-12 ma-sm-6 ma-2">
                              <v-row  >
                                <v-col cols="12" sm="12" md="12" lg="12">
                                  <v-form ref="form">
                                    <v-row>
                                      <v-col cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field  style="font-size: xx-small"  label="DNI O CE" value=" " disabled ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="5" lg="5" style="font-size: xx-small" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field style="font-size: xx-small" label="Email" value=" " disabled  ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field   label="Nombres" disabled value=" "></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field  label="ApPaterno" value=" " disabled></v-text-field>
                                      </v-col>
                                      <v-col v-if="campoapmaterno"  cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field  label="ApMaterno" value=" " disabled></v-text-field>
                                      </v-col>
                                      <v-col  v-if="campotelefono" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field type="number" value=" " disabled  label="Telefono"></v-text-field>
                                      </v-col>
                                      <v-col  v-if="campodireccion"  cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field    label="Direccion" value=" " disabled></v-text-field>
                                      </v-col>
                                      <v-col v-if="campodistrito" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field value=" " disabled
                                            label="Pais"></v-text-field>
                                      </v-col>
                                      <v-col v-if="campodistrito" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field   label="Departamento" disabled value=" "></v-text-field>
                                      </v-col>
                                      <v-col v-if="campodistrito" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field  label="Provincia" disabled value=" "
                                        ></v-text-field>
                                      </v-col>
                                      <v-col v-if="campodistrito" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field label="Distrito" disabled value=" "></v-text-field>
                                      </v-col>
                                      <v-col v-if="camposexo" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field
                                            label="Sexo" disabled value=" "></v-text-field>
                                      </v-col>
                                      <v-col v-if="campofecnac" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field
                                            label="Fecha Nacimiento" disabled value=" "></v-text-field>
                                      </v-col>
                                      <v-col v-if="camporeferido" cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field  disabled value=" " label="Referido"></v-text-field>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="5" lg="5" class="mt-0 pt-0 mb-0 pb-0">
                                        <v-text-field disabled value=" "

                                            label="Contacto"></v-text-field>
                                      </v-col>
                                      <v-col  cols="12" sm="12" md="12">
                                        <v-row>

                                          <v-col md="12" lg="12" cols="12">
                                            <v-file-input
                                                label="Subir Foto de Cara, sin lentes de sol o gorra"

                                            ></v-file-input>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-col cols="12" sm="12" md="12">

                                        <v-checkbox

                                        ></v-checkbox>  </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col>
                                        <v-btn >Enviar</v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-form>
                                </v-col>
                              </v-row>
                            </section>

                          </v-col>
                          <v-col cols="2">

                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
             </v-col>
           </v-row>
         </v-card-text>

       </v-card>
        </v-col>
      </v-row>
      <leftmenu :abreviado="abreviado" />
    </v-container>
  </v-main>
</v-app>
</template>

<script>
import Cabecerabaja from "@/components/general/cabecerabaja";
import Leftmenu from "@/components/general/leftmenu";
import {mapGetters} from "vuex";
import firebase from 'firebase/compat/app';

export default {
  name: "membresiadisenio",
  components: {Leftmenu, Cabecerabaja},
  data: () => ({
    abreviado:'',
    idnegocio:'',
    overlay:false,
    campoapmaterno:false,
    campodireccion: false,
    campodistrito:false,
    campofecnac: false,
    campofoto:false,
    campoinvitado: false,
    camporeferido:false,
    camposexo:false,
    campotelefono:false,
    negocio:{}
  }),
  mounted() {
    this.idnegocio =  this.$route.params.idnegocio
    this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    this.overlay = true
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.overlay = false
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })

    }else{
      this.overlay = false
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
    }
  },
  methods:{

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      dias: "dias"
    })
  }
}
</script>

<style scoped>

</style>
